import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Replaces the plain empty-state text with the page's own content (e.g. a call to action).
 */
@Directive({ selector: 'ng-template[esnTableEmpty]' })
export class TableEmptyDirective {
  readonly template = inject<TemplateRef<void>>(TemplateRef);
}
